import { getManualValueShape } from "web_myplann/Portfolio/PortfolioShared/getManualValueShape";
import { toolPreviousValueSchema } from "web_myplann/Portfolio/PortfolioShared/ManualValue/toolPreviousValueSchema";
import { refineManualValue } from "web_myplann/Portfolio/PortfolioShared/refineManualValue";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const getToolValueFormSchema = (t: TranslateFunction) =>
	z
		.object({
			...getManualValueShape(t),
			previousValues: z.array(toolPreviousValueSchema),
		})
		.superRefine(refineManualValue(t));

export type ToolValueFormInput = z.input<
	ReturnType<typeof getToolValueFormSchema>
>;
export type ToolValueFormOutput = z.output<
	ReturnType<typeof getToolValueFormSchema>
>;
